import store from '@/state/store'

const fields = [
  {
    key: 'date',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'fuelStart',
    label: 'report.fields.fuelStart',
    header: 'fuelStart',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'fuelStartPercentage',
        label: 'report.fields.percentage',
        header: 'percentage',
        width: 20,
        childOfIndex: 0,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'fuelStartVolume',
        label: 'report.fields.volume',
        header: 'volume',
        width: 20,
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'fuelEnd',
    label: 'report.fields.fuelEnd',
    header: 'fuelEnd',
    filter: false,
    width: 30,
    isLocked: true,
    children: [
      {
        key: 'fuelEndPercentage',
        label: 'report.fields.percentage',
        header: 'percentage',
        childOfIndex: 1,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'fuelEndVolume',
        label: 'report.fields.volume',
        header: 'volume',
        childOfIndex: 1,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'refueling',
    label: 'report.fields.refueling',
    header: 'refueling',
    filter: false,
    width: 30,
    isLocked: true,
    children: [
      {
        key: 'refuelingCount',
        label: 'report.fields.count',
        header: 'count',
        childOfIndex: 2,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'refuelingVolume',
        label: 'report.fields.volume',
        header: 'volume',
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'fuelLoss',
    label: 'report.fields.fuelLoss',
    header: 'fuelLoss',
    filter: false,
    width: 30,
    isLocked: true,
    children: [
      {
        key: 'fuelLossCount',
        label: 'report.fields.count',
        header: 'count',
        childOfIndex: 3,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'fuelLossVolume',
        label: 'report.fields.volume',
        header: 'volume',
        childOfIndex: 3,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'sensorType',
    label: 'report.fields.sensorType',
    header: 'sensorType',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'totalFuel',
    label: 'report.fields.fuelUsage',
    header: 'totalFuel',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'totalDistance',
    label: 'report.fields.distance',
    header: 'totalDistance',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'totalHours',
    label: 'report.fields.travelDuration',
    header: 'totalHours',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'idleDuration',
    label: 'report.fields.idleDuration',
    header: 'idleDuration',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
]

if (!store.getters['identity/hasAccess'](['fuel_efficiency_v2:read'])) {
  fields.push(
    {
      key: 'actualEfficiency',
      label: 'report.fields.actualEfficiency',
      header: 'actualEfficiency',
      filter: false,
      width: 20,
      headerRowspan: 2,
    },
    {
      key: 'standardEfficiency',
      label: 'report.fields.stdEfficiency',
      header: 'standardEfficiency',
      filter: false,
      width: 20,
      headerRowspan: 2,
    },
    {
      key: 'statusEfficiency',
      label: 'report.fields.statEfficiency',
      header: 'statusEfficiency',
      filter: false,
      width: 20,
      headerRowspan: 2,
    }
  )
}

export default fields
